import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectDataPartnerPatient, selectDataPatient } from 'connect/selectors';
import { useIsPartnerUser } from 'utils/customHooks/use-partner-user';

/**
 * Hook that determines the appropriate patient information for checkout
 * based on the current user type.
 *
 * For the authenticated partner user it returns the associated partner patient data.
 * For all other users (regular), it returns the current patient's data.
 */
export const useCheckoutPatient = () => {
  const isPartnerUser = useIsPartnerUser();
  const currentPatient = useSelector(selectDataPatient);
  const partnerPatient = useSelector(selectDataPartnerPatient);

  return useMemo(
    () => isPartnerUser ? partnerPatient : currentPatient,
    [isPartnerUser, partnerPatient, currentPatient],
  );
};
